import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Currency } from '../lib/components/Currency';
import { WithApiAccess } from "../lib/HigherOrderComponents/WithApiAccess";
import { LoadingSpinner } from '../lib/components/LoadingSpinner';
import { FormattedDate } from '../lib/components/FormattedDate';
import { PhoneNumber } from '../lib/components/PhoneNumber';
import { Percent } from '../lib/components/Percent';
import { Address } from '../lib/components/Address';
import { withHeaderMessages } from '../higherOrderComponents/WithHeaderMessages';
import './clearpoint-reports.css';

const ConfirmationReceiptGenericPrint = (props) => {

  const { contract, downPayment, fundingOptions } = props;
  if (!contract || downPayment === null || !fundingOptions) {
    return <LoadingSpinner />;
  }

  const merchandiseTotal = contract.purchases.filter(p => p.group === "Merchandise").map(p => p.netPrice).reduce((a, b) => a + b, 0);
  const servicesTotal = contract.purchases.filter(p => p.group === "Services").map(p => p.netPrice).reduce((a, b) => a + b, 0);
  const burialRightsTotal = contract.purchases.filter(p => p.group === "Burial Rights").map(p => p.netPrice).reduce((a, b) => a + b, 0);
  const cashAdvancesTotal = contract.purchases.filter(p => p.group.startsWith("Cash Advance")).map(p => p.netPrice).reduce((a, b) => a + b, 0);
  const feesTotal = contract.purchases.filter(p => p.group === "Fees").map(p => p.netPrice).reduce((a, b) => a + b, 0);

  return (
    <div>
      <Row>
        <Col xs={12} style={{ textAlign: "center" }}>
          <img src="/images/Clearpoint_Confirmation_Receipt_Logo.png" alt="header" />
        </Col>
      </Row>
      <Row>
        <Col xs={12} style={{ textAlign: "center", paddingTop: "10px" }}>
          <h4>Confirmation Receipt and Request for Distribution</h4>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <label>ClearPoint Federal Bank &amp; Trust</label>
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <Row className="confirmation-row">
            <Col>
              <label>Cemetery Provider:</label>
              <div>
                {contract.provider.name}<br />
                <Address address={contract.provider.address} />
              </div>
            </Col>
          </Row>
          <Row className="confirmation-row">
            <Col>
              <label>Payment Plan:</label> {contract.paymentPlan}
            </Col>
          </Row>
          <Row className="confirmation-row">
            <Col>
              <label>Purchaser:</label>
              <div>
                {contract.purchaser.firstName} {contract.purchaser.lastName}<br />
                <Address address={contract.purchaser.address} />
              </div>
            </Col>
          </Row>
          <Row className="confirmation-row birth-date">
            <Col xs={4} style={{ padding: "0" }}>
              <label>DOB:</label> <FormattedDate date={contract.purchaser.dateOfBirth} />
            </Col>
            <Col xs={4} style={{ padding: "0" }}>
              <label>Sex:</label> {contract.purchaser.gender}
            </Col>
          </Row>
          <Row className="confirmation-row">
            <Col>
              <label>Phone:</label> <PhoneNumber phoneNumber={contract.purchaser.phoneNumber} />
            </Col>
          </Row>
        </Col>
        <Col xs={6}>
          <Row className="confirmation-row2 pl-15" style={{ marginTop: "0in" }}>
            <Col>
              <label>Contract Number:</label> {contract.number}
            </Col>
          </Row>
          <Row className="confirmation-cemetery-row-col2 pl-15">
            <Col>
              <label>Contract Ref Number:</label> {contract.providerNumber}
            </Col>
          </Row>
          <Row className="confirmation-cemetery-row-col2 pl-15">
            <Col>
              <label>Date Accepted:</label> <FormattedDate date={contract.accepted} format="MMMM D, YYYY" />
            </Col>
          </Row>
          <Row className="confirmation-cemetery-row-col2 pl-15">
            <Col>
              <label>Merchandise Total:</label> <Currency amount={merchandiseTotal} />
            </Col>
          </Row>
          <Row className="confirmation-cemetery-row-col2 pl-15">
            <Col>
              <label>Services Total:</label> <Currency amount={servicesTotal} />
            </Col>
          </Row>
          <Row className="confirmation-cemetery-row-col2 pl-15">
            <Col>
              <label>Property Total:</label> <Currency amount={burialRightsTotal} />
            </Col>
          </Row>
          <Row className="confirmation-cemetery-row-col2 pl-15">
            <Col>
              <label>Cash Advance:</label> <Currency amount={cashAdvancesTotal} />
            </Col>
          </Row>
          <Row className="confirmation-cemetery-row-col2 pl-15">
            <Col>
              <label>Fees:</label> <Currency amount={feesTotal} />
            </Col>
          </Row>
          <Row className="confirmation-cemetery-row-col2 pl-15">
            <Col>
              <label>Finance Rate %:</label> <Percent amount={contract.interestRate} />
            </Col>
          </Row>

          <Row className="mt-15 pl-15">
            <Col>
              <label>Funding Option(s):</label>
              {fundingOptions.map((f, i) =>
                <div key={i}>{f}<br /></div>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Row className="confirmation-row mt-15" style={{ textAlign: "center" }}>
            <label>Other Information</label>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col xs={7}>
          <Row className="confirmation-row" style={{ marginTop: "0" }}>
            <Col>
              Tax Recipient: <label>{contract.taxRecipient ? contract.taxRecipient.firstName : ''} {contract.taxRecipient ? contract.taxRecipient.lastName : ''}</label>
            </Col>
          </Row>
          <Row className="confirmation-row" style={{ marginTop: "0" }}>
            <Col>
              Merchandise &amp; Service Tax Treatment: <label>{contract.taxTreatment}</label>
            </Col>
          </Row>
        </Col>
        <Col xs={5}>
          <Row className="confirmation-row" style={{ marginTop: "0" }}>
            <Col>
              Guaranteed: <label>{contract.guaranteed === true ? "Yes" : "No"}</label>
            </Col>
          </Row>
          <Row className="confirmation-row" style={{ marginTop: "0" }}>
            <Col>
              Irrevocable: <label>{contract.irrevocable === true ? "Yes" : "No"}</label>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Row className="confirmation-row">
            <Col>
              This document is intended as a convenience to our customers and is not to be construed as a part of any agreement or document related to your cemetery merchandise and services trust. If this information differs in any way from the information in your trust documents, please call us immediately at 1-800-763-0234.
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="mb-15">
        <Col xs={6}>
          <Row className="confirmation-row">
            <Col>
              This document is both an acknowledgement that funds have been placed into trust or escrow by CFBT and is also to be used to distribute funds to the provider
            </Col>
          </Row>
          <Row className="confirmation-row">
            <Col>
              <strong>It is imperative that you retain the original form with your records.</strong>
            </Col>
          </Row>
          <Row className="confirmation-row">
            <Col>
              We reserve the right to request a copy of the bill for merchandise and services provided. Depending upon the funding option selected, a tax statement may be issued annually, or following the distribution of the funds. For specific information regarding the funding option that you have selected, please refer to the "Funding Option Summary" sheet.
            </Col>
          </Row>
        </Col>
        <Col xs={6}>
          <Row className="confirmation-row">
            <Col>
              Please complete and sign all indicated areas on the reverse side of this form when requesting distributions.
            </Col>
          </Row>
          <Row className="confirmation-row">
            <Col>
              <p>
                <strong>
                  ClearPoint Federal Bank &amp; Trust<br />
                  P.O. Box 59<br />
                  Batesville, IN 47006
                </strong>
              </p>
              <p><strong>Fax: 1-866-208-1236</strong></p>
              <p><strong>Telephone: 1-800-763-0234 Customer Service</strong></p>
            </Col>
          </Row>
        </Col>
      </Row>
      {/* Page two */}
      <Row style={{ pageBreakBefore: "always" }}>
        <Col xs={6} className='ps-0'>
          <Row className="ms-0">
            <Col>
              {contract.provider.name}<br />
              <Address address={contract.provider.address} />
            </Col>
          </Row>
        </Col>
        <Col xs={6}>
          <Row className="ml-0">
            <Col>
              <label>Contract Number:</label> {contract.number}
            </Col>
          </Row>
          <Row className="ml-0">
            <Col>
              <label>Contract Ref Number:</label> {contract.providerNumber}
            </Col>
          </Row>
          <Row className="ml-0">
            <Col>
              <label>Purchaser:</label> {contract.purchaser.firstName} {contract.purchaser.lastName}
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="mt-15">
        <Col xs={12} className='ps-0'>
          <Row className="ms-0">
            <strong>Please check the item for which you are requesting distribution and sign. (Allowance for partial distribution based on State Regulations)</strong>
          </Row>
        </Col>
      </Row>
      <Row className="purchases-row mt-15">
        <Col xs={12}>
          <table>
            <thead>
              <tr>
                <th style={{ width: "60px" }}>Check Item(s)</th>
                <th style={{ width: "180px" }}>Recipient</th>
                <th style={{ width: "20px" }}>&nbsp;</th>
                <th style={{ width: "20px" }}>&nbsp;</th>
                <th style={{ width: "200px" }}>Item Description</th>
                <th style={{ width: "100px" }}>Net Price</th>
                <th style={{ width: "180px" }}>Provider Initials/Date</th>
              </tr>
            </thead>
            <tbody>
              {contract.purchases.map((p, i) => (
                <tr key={i} style={{ height: "40px" }}>
                  <td>[&nbsp;&nbsp;&nbsp;]</td>
                  <td>{p.recipients}</td>
                  <td>{p.itemNumber}</td>
                  <td>-</td>
                  <td>{p.description}</td>
                  <td><Currency amount={p.netPrice} /></td>
                  <td>_______________________</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Col>
      </Row>
      <Row className="mt-0" style={{ borderBottom: "1px solid black" }}>
        <Col xs={12}>
          [&nbsp;&nbsp;&nbsp;] Request payment for distribution of all items<br />&nbsp;
        </Col>
      </Row>
      <Row className="mt-15">
        <Col xs={12}>
          <p>I certify that all the above items were delivered for the above stated contract. In addition, I understand that the Trustee and its agents reserve the right to request more information if required. If this form is not signed by the recipient's next of kin or legal representative at the time of final distribution, I certify the merchandise and / or services have been provided.</p>
        </Col>
      </Row>
      <Row className="mt-15">
        <Col xs={7} className='cemetery-col-label'>
          <Row className="ml-0">
            <Col>
              X______________________________________________________
            </Col>
          </Row>
          <Row className="ml-0">
            <Col style={{ textAlign: "center" }} className='cemetery-col-label text-center'>
              Signature of Authorized Cemetery Representative
            </Col>
          </Row>
        </Col>
        <Col xs={3}>
          <Row className="ml-0">
            <Col>
              X__________________
            </Col>
          </Row>
          <Row className="ml-0">
            <Col style={{ textAlign: "center" }}>
              Date
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="mt-15">
        <Col xs={7} className='cemetery-col-label'>
          <Row className="ml-0">
            <Col>
              ______________________________________________________
            </Col>
          </Row>
          <Row className="ml-0">
            <Col style={{ textAlign: "center" }} className='cemetery-col-label'>
              Print Name
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="mt-15">
        <Col xs={7} className='cemetery-col-label'>
          <Row className="ml-0">
            <Col>
              X______________________________________________________
            </Col>
          </Row>
          <Row className="ml-0">
            <Col style={{ textAlign: "center" }} className='cemetery-col-label'>
              Signature of Legal Representative*
            </Col>
          </Row>
        </Col>
        <Col xs={3}>
          <Row className="ml-0">
            <Col>
              X__________________
            </Col>
          </Row>
          <Row className="ml-0">
            <Col style={{ textAlign: "center" }}>
              Date
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="mt-15">
        <Col xs={7} className='cemetery-col-label'>
          <Row className="ml-0">
            <Col>
              ______________________________________________________
            </Col>
          </Row>
          <Row className="ml-0">
            <Col style={{ textAlign: "center" }} className='cemetery-col-label'>
              Relationship to Recipient
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="mt-15">
        <Col xs={12}>
          * Only needed at time of final distribution (if required by State Law).
        </Col>
      </Row>
      <Row className="mt-15">
        <Col xs={12}>
          IMPORTANT: Retain this document for your records - it must be submitted to ClearPoint Federal Bank &amp; Trust by the cemetery at the time of partial and final distribution.
        </Col>
      </Row>
    </div>
  );
}

export default withHeaderMessages(WithApiAccess(ConfirmationReceiptGenericPrint));
